module.exports = __webpack_public_path__ + "static/media/CompetitorData.d5e376e7.docx";